import { axiosInstance } from "@/util/AxiosModule"
import store from "@/store";
import router from "@/router";

const getDefaultState = () => {
    return {
        accessToken: "",
        refreshToken: "",
        memberId: "",
        memberRole: "",
        userData: {}
    };
};

// initial state
const state = getDefaultState();

const getters = {
    accessToken: state => state.accessToken,
    refreshToken: state => state.refreshToken,
    memberId: state => state.memberId,
    memberRole: state => state.memberRole,
    userData: state => state.userData,
    isAdmin: state => state.memberRole === "ADMIN",
    isManager: state => state.memberRole === "MANAGER",
    isUser: state => state.memberRole === "USER"
};

const actions = {
    async login({ commit, dispatch }, { accessToken, refreshToken, memberId, memberRole }) {
        commit("login", { accessToken, refreshToken, memberId, memberRole });
        dispatch("setUserData", memberId);
    },
    async initData({ commit }) {
        commit("initData");
    },
    async logout({ commit }, id) {
        await axiosInstance.post("/private/logout", {}, {
            params: {id: id}
        })
            .then(() => {
                commit("logout");
                router.push("/login");
            })
            .catch(function (error) {
                store.dispatch("dialog/showAlert", {
                    message: `${error.response.data.message}`
                })
            })
    },
    async setUserData({ commit }, id) {
        await axiosInstance
            .get("/private/member/info", {
                params: {
                    memberId: id
                }
            })
            .then(res => {
                commit("setUserData", res.data);
                router.push({ name: "MainPage"});
            })
            .catch(function(error) {
                if (error.response.status === 500) {
                    if (error.response.data.code === "INVALID_TOKEN")
                        console.log(error);
                    else
                        store.dispatch("dialog/showAlert", {
                            message: `${error.response.data.message}`
                        });
                }
            });
    }
};

// mutations
const mutations = {
    login(state, { accessToken, refreshToken, memberId, memberRole }) {
        state.accessToken = accessToken;
        state.refreshToken = refreshToken;
        state.memberId = memberId;
        state.memberRole = memberRole;
    },
    logout(state) {
        let data = getDefaultState();
        Object.assign(state, data);
    },
    initData(state) {
        state.accessToken = "";
        state.refreshToken = "";
        state.memberId = "";
        state.memberRole = "";
        state.userData = [];
    },
    setUserData(state, data) {
        state.userData = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};